import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
	state,
	actions,
	getters,
	mutations,
	name: 'class-level',
	props: {
		label: {
			type: String,
			default: 'Nível de ensino'
		},
		required: {
			type: Boolean,
			default: false
		},
		blacklist: {
			type: Array,
			default: () => []
		}
	},
	data: () => ({
		classLevelModel: '',
		schoolClassLevels: ''
	}),
	computed: {
		...mapGetters([
			'ENUM',
			'classLevel'
		])
	},
	methods: {
		...mapActions([
			'setSelectedClassLevel'
		]),
		changed() {

			this.setSelectedClassLevel(this.classLevelModel);
			EventBus.$emit('classLevelSelected', this.classLevelModel);

		}
	},
	mounted() {

		if (this.classLevel) {
			this.classLevelModel = this.classLevel;
		}

		this.schoolClassLevels = cloneDeep(this.ENUM.SchoolClassLevelType);

		if (this.blacklist.length) {

			this.blacklist.forEach((value) => {
				delete this.schoolClassLevels[value];
			});

		}

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-level/index.js